import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth/auth.service.service';
import { SharedService } from '../services/Shared/Shared.service';
import { Router, ActivatedRoute } from '@angular/router';
import { cloudsearch } from 'googleapis/build/src/apis/cloudsearch';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  
  public copyRightsDate : Date = new Date();
  public loginData = {
    EmailAddress: null,
    Password:null
  };
  public loginResult;
  public ForgotPasswordEmail;
  public btnSignIn = false;
  public btnSignInText = "SIGN IN";
  public CompanyLogo = "";
  public CompanyLogoBg = "";

  constructor(
    private loginService: AuthService,
    private sharedService: SharedService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    const qsParam: string = this.activatedRoute.snapshot.queryParamMap.get('c');
    if(qsParam){
      
      this.CompanyLogo = '../assets/img/Company/' + qsParam + '/logo_login.png';
      this.CompanyLogoBg = "../assets/img/Company/"+ qsParam +"/login_bg.png"; 

      fetch(this.CompanyLogo, { method: 'HEAD' })
      .then(res => {
          if (res.ok) {
              //console.log('Image exists.');
          } else {
            this.CompanyLogo = "../assets/img/ba-logo.png";
          }
      }).catch(err => console.log('Error:', err));

      fetch(this.CompanyLogoBg, { method: 'HEAD' })
      .then(res => {
          if (res.ok) {
              //console.log('Image exists.');
          } else {
            this.CompanyLogoBg = "../assets/img/login_bg.png";
          }
      }).catch(err => console.log('Error:', err));
    
    }
    else{
      this.CompanyLogo = "../assets/img/ba-logo.png";
      this.CompanyLogoBg = "../assets/img/login_bg.png";
    }
  }

  login(){
    this.btnSignIn = true;
    this.btnSignInText = "Wait..."
    this.loginService.login(this.loginData).subscribe(result => {
      //console.log(result)
      if(result){
        this.loginResult = result;
        
        //Create Local and session variable for logged in user
        this.sharedService.setUserDetail(result);

        try{
          var userEmailDomain = this.loginData.EmailAddress.split("@",2);
          sessionStorage.setItem('UserEmailDomain', userEmailDomain[1]);
        }
        catch(ex){}

        
        if(this.sharedService.getUserDetail('RoleId') == 4){
          if(this.sharedService.getUserDetail('CompanyIndustry') == "HealthSight"){
            this.router.navigate(['../site/epi']); 
          }
          else{
            if(this.sharedService.getUserDetail('CompanyId') == '6495acda0a1d2135d04b5060'){
              this.router.navigate(['../site/news']);
            }
            else{
              this.router.navigate(['../site/dashboard']);
            }
             
          }       
        }
        else{
          this.router.navigate(['../admin/user/user-listing']);  
        }
             
      }
    }, error => {
      this.btnSignIn = false;
      this.btnSignInText = "SIGN IN"
      //console.log('Error: Login' + error.reason + error.status);
      if(error.status == 403)
      {
        $(".error-msg").text(error.reason).show().delay(5000).fadeOut();
      }else{
        $(".error-msg").text('Login failed').show().delay(5000).fadeOut();
      }     
    })
  }

  forgotpassword(){
      this.loginService.GetUser(this.ForgotPasswordEmail).subscribe(result => {        
        if(result){
          this.loginResult = result;
          var request =
          {​​​​​​​​
            email: this.ForgotPasswordEmail,
            emailSubject : "CI Portal : Forgot Password",
            emailBody: "Your Password is "+ this.loginResult[0].Password
          }​​​​​​​​     
          this.ForgotPasswordEmail = "";
          this.loginService.ForgotPassword(request).subscribe(result => {        
            if(result){
              $(".errorfp-success").text('Email sent successfully').show().delay(5000).fadeOut();   
              return false; 
            }
          }, error => {
            //console.log('Failed to send email.' + error.reason + error.status);     
            $(".errorfp-msg").text(error.reason).show().delay(5000).fadeOut();   
            return false; 
          })
        }
      }, error => {
        this.ForgotPasswordEmail = ""
        //console.log('Failed to send email.' + error.reason + error.status);    
        if(error.status == 404)
        {         
          $(".errorfp-msg").text('Email sent successfully..!!').show().delay(5000).fadeOut();  
          return false;
        }else{           
          $(".errorfp-msg").text(error.reason).show().delay(5000).fadeOut(); 
          return false;  
        }
             
      })


    
  }

  FP(){
    this.ForgotPasswordEmail = ""
  }
  imageExists(url, callback) {
    var img = new Image();
    img.onload = function() { callback(true); };
    img.onerror = function() { callback(false); };
    img.src = url;
  }


}
